<template>
    <div class="text">
        <div class="flex">
            <label class="required">
                Height of Brace
            </label>
            <div class="help">
                <modal tooltip="click for help with NFPA brace height adjustment" :result="helpImg" text="" link-classes="fa fa-question"/>
            </div>
        </div>
        <div class="select">
            <select 
                v-model="selectValue" 
                v-on:change="$emit('change', $event.target.value)"
                required 
                placeholder="Height of component attachment to structure as a percentage of the average roof height"
            >
                <option v-for="height in options" :value="height.value" v-text="height.name"></option>
            </select>
        </div>
        <p class="note">Height of component attachment to structure as a percentage of the average roof height</p>
    </div>
</template>

<script>
import Modal from '../_modal';
export default {
    components: {
        Modal,
    },
    props: {
        value: {type: [String, Number]},
    },
    mounted() {
        this.selectValue = this.value;
    },
    data() {
        return {
            selectValue: null,    
            options: [
                { name: '< 50% building height', value: .5 },
                { name: '51% to 75% building height', value: .75 },
                { name: '> 75% building height', value: 1 },
            ],
            helpImg: '/img/seismic/nfpa-13-2022-18.5.9.3-height-adjustment.png'
        }
    },
    mounted() {
        this.selectValue = parseFloat(this.value);
    },
}
</script>